import { StompSessionProvider } from "react-stomp-hooks";
import MenuAppBar from "../components/app/AppBar";
import { WEB_SOCKET_ENABLED, WEB_SOCKET_URL } from "../api";

export function MainContainer() {
    return (
        <>
            <StompSessionProvider
                url={WEB_SOCKET_URL}
                enabled={WEB_SOCKET_ENABLED}>
                <MenuAppBar />
            </StompSessionProvider>
        </>
    )
}